/**
 * @ngdoc directives
 * @memberof mercury.directives
 * @name sidenav
 * @description The side bar navigation element
 */
angular
  .module("mercury.directives.sidenav", [])
  .directive(
    "sidenav",
    ["$filter", "$state", "$stateParams", "$timeout", "userinfo", "applicationMenu", function (
      $filter,
      $state,
      $stateParams,
      $timeout,
      userinfo,
      applicationMenu
    ) {
      return {
        restrict: "A",
        templateUrl: "directives/sidenav/sidenav.tpl.html",
        link: function (scope, element) {
          // Configuration for any early access icons, and the messages that should
          // be shown for each.
          //
          // This isn't the most elegant approach, but we want something lightweight.
          const earlyAccessSubMenuItems = {
            "Stock.ReportReceivedInvoices": {
              message: "Want access to our AI-powered invoice processing?",
              link: "https://loadedhub.notion.site/Early-Access-AI-powered-Invoice-Processing-4bbe733b413743dbb83a63730a34bc44?pvs=74",
            },
            "Stock.Invoices": {
              message: "Want access to our AI-powered invoice processing?",
              link: "https://loadedhub.notion.site/Early-Access-AI-powered-Invoice-Processing-4bbe733b413743dbb83a63730a34bc44?pvs=74",
            },
            "Stock.InvoiceHistory": {
              message: "Want access to our AI-powered invoice processing?",
              link: "https://loadedhub.notion.site/Early-Access-AI-powered-Invoice-Processing-4bbe733b413743dbb83a63730a34bc44?pvs=74",
            },
          };

          const newSubMenuItems = {
            "Stock.Menus": {
              title: "Enhanced menu management",
              message: "A refreshed menu management experience which now includes stock received via AI Invoice Processing in COGs calculations.",
            },
            "Stock.StockOnHand": {
              title: "Smarter Stock on Hand insights",
              message: "This report now includes stock received via AI Invoice Processing, and lets you see stock levels on any past date.",
            }
          };

          scope.hideIcons = window.localStorage.getItem('@@loaded/alpha-styles') != 'true' ||
            window.localStorage.getItem('@@loaded/alpha-styles-no-icons') == 'true';

          scope.setOpen = function (index) {
            scope.openIndex = index;
          };

          var updateMenu = function () {
            scope.activeMenuLink =
              $state.current.data && $state.current.data.menuLinkState
                ? $state.current.data.menuLinkState
                : $state.current.name;
            if ($state.params) {
              scope.stateParams = $state.params;
            }
            scope.openIndex = -1;

            angular.forEach(scope.sidenav, function (nav, navIndex) {
              if (nav.state && scope.activeMenuLink == nav.state) {
                scope.openIndex = navIndex;
                scope.subMenu = null;
                element.removeClass("submenu-open");
              } else if (nav.subMenu) {
                angular.forEach(nav.subMenu, function (subnav) {
                  if (subnav.state && scope.activeMenuLink == subnav.state) {
                    scope.openIndex = navIndex;
                    scope.subMenu = nav.subMenu;

                    // Any sub menu items that are configured for early access get
                    // the configuration assigned for use in the template, any that
                    // aren't get null which ensures the icon isn't shown at all.
                    scope.subMenu.forEach(function (item) {
                      item.earlyAccess = earlyAccessSubMenuItems[item.state];
                      item.newBadge = newSubMenuItems[item.state] || null;
                    });

                    element.addClass("submenu-open");
                  }
                });
              }
            });
          };

          scope.currentModule = $state.current.name.split(".")[0];

          scope.loading = applicationMenu.getMenu();

          var layout = $state.current.name.split(".")[0];

          if (layout == "Settings") {
            scope.sidenav = [
              {
                label: "Account",
                state: "Settings.CompanyList",
                iconImage: "MultiSite.png",
              },
              {
                label: "User Profile",
                state: "Settings.Profile",
                iconImage: "MultiSite.png",
              },
              {
                label: "Privacy Policy",
                href: "/privacy-policy",
                iconImage: "MultiSite.png",
              },
              {
                label: "End User Licence Agreement",
                href: "/end-user-licence-agreement",
                iconImage: "MultiSite.png",
              },
            ];
            scope.showbackbutton = true;
            updateMenu();
          } else if (layout == "Admin") {
            scope.sidenav = [
              {
                label: "Companies",
                state: "Admin.CompanyList",
                iconImage: "MultiSite.png",
              },
              {
                label: "Users",
                state: "Admin.UserList",
                iconImage: "MultiSite.png",
              },
              {
                label: "Databases",
                state: "Admin.DatabaseList",
                iconImage: "MultiSite.png",
              },
              {
                label: "Importers",
                state: "Admin.ImporterList",
                iconImage: "MultiSite.png",
              },
              {
                label: "Stock",
                iconImage: "MultiSite.png",
                subMenu: [
                  { label: "Suppliers", state: "Admin.StockSuppliers" },
                ],
              },
            ];
            scope.showbackbutton = true;
            updateMenu();
          } else {
            scope.loading.then(function (companyReports) {
              scope.companyReports = companyReports;

              var menu = $filter("filter")(scope.companyReports, {
                label: layout,
              });
              if (menu.length === 1) {
                scope.sidenav = menu[0].menuItems;
              }

              if (scope.sidenav) {
                scope.showbackbutton = false;
              } else {
                scope.showbackbutton = true;
              }

              updateMenu();
            });
          }

          scope.$on("$stateChangeSuccess", function () {
            $timeout(function () {
              updateMenu();
            });
          });

          scope.linkActive = function (nav) {
            return (
              nav.state == scope.activeMenuLink &&
              (nav.state != "Reports.ItemsProducts" ||
                nav.stateParams.categoryId == scope.stateParams.categoryId)
            );
          };
        },
      };
    }]
  );
